import { render, staticRenderFns } from "./CropperBack.vue?vue&type=template&id=35726ffa&"
import script from "./CropperBack.vue?vue&type=script&lang=js&"
export * from "./CropperBack.vue?vue&type=script&lang=js&"
import style0 from "./CropperBack.vue?vue&type=style&index=0&id=35726ffa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports